import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { AuthState } from './types';
import { RootState } from '../../types';
import { state } from './state';

const namespaced: boolean = true;

export const auth: Module<AuthState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};

export enum AUTHORITIES {
  ADMIN = 'ROLE_ADMIN',
  MANAGER = 'ROLE_MANAGER',
  EMPLOYEE = 'ROLE_EMPLOYEE',
  TRAINER = 'ROLE_TRAINER',
  ATTENDEE = 'ROLE_ATTENDEE',
  INTERESTED = 'ROLE_INTERESTED',
}

export function getHighestAuthority(authorities: string[]): AUTHORITIES | undefined {
  if (authorities.includes(AUTHORITIES.ADMIN)) return AUTHORITIES.ADMIN;
  if (authorities.includes(AUTHORITIES.MANAGER)) return AUTHORITIES.MANAGER;
  if (authorities.includes(AUTHORITIES.EMPLOYEE)) return AUTHORITIES.EMPLOYEE;
  if (authorities.includes(AUTHORITIES.TRAINER)) return AUTHORITIES.TRAINER;
  if (authorities.includes(AUTHORITIES.ATTENDEE)) return AUTHORITIES.ATTENDEE;
  if (authorities.includes(AUTHORITIES.INTERESTED)) return AUTHORITIES.INTERESTED;
  return undefined;
}